import { inflect } from 'inflection'
import { match } from 'ts-pattern'

import type { SendReminder } from '../..'

export const formatSendReminder = (sendReminder: SendReminder): string => {
  const days = sendReminder.duration.days ?? 0
  const direction = match(sendReminder.type)
    .with('BEFORE_DUE_DATE', () => 'before')
    .with('AFTER_DUE_DATE', () => 'after')
    .exhaustive()

  return `${days} ${inflect('day', days)} ${direction} due date`
}
